<template>
  <div>
    <footer class="footer">
      <div class="d-flex justify-content-center">
        <div class="copyrights">
          <div class="container">
            <p style="color:white ; font-family:'Times New Roman', Times, serif">
              &copy; 2020 - {{year}} Aslan Yazılım Tüm Hakları Saklıdır
            </p>

            <div class="credits"></div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
  data() {
    return {
      year : new Date().getFullYear(),
    };
  },
  created() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/default/Footer.vue